import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@langchain/untitled-ui-icons';
import { Box, Button, Stack } from '@mui/joy';

function getPageNums(page: number, lastPage: number): (number | '...')[] {
  // show 7 page nums.

  // if there are 7 or fewer pages, show all of them
  if (lastPage < 7) {
    return [...Array(lastPage + 1).keys()];
  }

  // if current page is 3 or less, show 0-5 and last
  if (page <= 3) {
    return [...Array(6).keys(), '...', lastPage];
  }

  // if current page is within 3 of the end, show 0 and last 6
  if (page >= lastPage - 3) {
    return [0, '...', ...[...Array(6).keys()].map((i) => i + lastPage - 5)];
  }

  // otherwise, show 0, current - 2, current - 1, current, current + 1, current + 2, last
  return [
    0,
    '...',
    page - 2,
    page - 1,
    page,
    page + 1,
    page + 2,
    '...',
    lastPage,
  ];
}

export default function Pagination({
  count,
  page,
  onChange,
}: {
  count: number;
  page: number;
  onChange: (e: any, newPage: number) => void;
}) {
  const pages = getPageNums(page, count - 1);
  if (pages.length <= 1) {
    return <></>;
  }

  return (
    <Stack flexDirection="row" alignItems="center" gap={1}>
      <Box flexGrow={1} />
      <Button
        variant="plain"
        color="neutral"
        disabled={page <= 0}
        onClick={(e) => onChange(e, page - 1)}
      >
        <ChevronLeftIcon className="size-4" />
      </Button>
      {pages.map((p) =>
        p !== '...' ? (
          <Button
            key={p}
            variant={p === page ? 'solid' : 'outlined'}
            color={p === page ? 'primary' : 'neutral'}
            onClick={(e) => onChange(e, p)}
          >
            {p + 1}
          </Button>
        ) : (
          <Box key={p}>{p}</Box>
        )
      )}
      <Button
        variant="plain"
        color="neutral"
        disabled={page >= count - 1}
        onClick={(e) => onChange(e, page + 1)}
      >
        <ChevronRightIcon className="size-4" />
      </Button>
      <Box flexGrow={1} />
    </Stack>
  );
}
